import { AsinTileData, KSavvyState, Store } from 'src/store';
import { TileZone } from 'src/arrangement/fulfillmentZones';

export const isFilteredOut = (asinTileData: AsinTileData, state: KSavvyState): boolean => {
  const isFilteredOutByBrand = !state.showFreshEvents && asinTileData.storeBrandName === 'Amazon Fresh'
    || !state.showWholeFoodsEvents && asinTileData.storeBrandName === 'Whole Foods Market';
  const selectedStoreIsNotAll = state.selectedStore.valueOf() !== Store.All.valueOf()
  const isFilteredOutByStore = state.selectedStore.valueOf() !== asinTileData.storeId.valueOf();
  const isFilteredOutByCustomer = state.focusCustomer.length >= 1 && state.focusCustomer != asinTileData.customerId;
  const isFilteredOutByASIN = state.focusASIN.length >= 1 && state.focusASIN != asinTileData.asin;
  const isFilteredOutByLiveOrReplay = state.replayFilter != asinTileData.liveOrReplay;
  return (selectedStoreIsNotAll && isFilteredOutByStore) || isFilteredOutByCustomer || isFilteredOutByASIN || isFilteredOutByLiveOrReplay || isFilteredOutByBrand;
};

export const getZone = (asinTileData: AsinTileData, state: KSavvyState): TileZone => {
  if (isFilteredOut(asinTileData, state)) {
    return 'FILTERED_OUT';
  } else {
    return asinTileData.animationData?.tileZone;
  }
};

export const getDestinationZone = (asinTileData: AsinTileData, state: KSavvyState): TileZone => {
  if (isFilteredOut(asinTileData, state)) {
    return 'FILTERED_OUT';
  } else {
    return asinTileData.animationData?.transition?.transitioningTo || 'FILTERED_OUT';
  }
};

export const zoneFilter = (asinTileData: AsinTileData, state: KSavvyState): boolean => {
  return getZone(asinTileData, state) !== 'FILTERED_OUT';
};
